if (!customElements.get('video-gallery')) {
  customElements.define(
    'video-gallery',
    class VideoGallery extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.section = this.closest(`.section-${this.sectionId}`);
        this.itemsWrapper = this.querySelector('.video-gallery__items');
        // Product-info galleries may share the section with other sliders
        // (e.g. the media gallery), so prefer a block-scoped controls root.
        this.controlsRoot = this.closest('[data-video-gallery-root]') || this.section;

        if (this.dataset.enableSlider !== 'true') return;

        const items = parseInt(this.dataset.items);
        const tabletItems = parseInt(this.dataset.tabletItems);
        const mobileItems = parseInt(this.dataset.mobileItems);
        const columnGap = FoxTheme.utils.getGridColumnGap(this.itemsWrapper);
        // Optional fractional extra slide (e.g. 0.25) so a part of the next
        // video stays visible and signals that more videos are available.
        const peek = parseFloat(this.dataset.peek || '0');

        // Switch the wrapper from a wrapping grid to a horizontal slider track.
        // Keep the f-grid--gap-* classes so column-gap CSS variables are preserved.
        this.itemsWrapper.classList.remove('f-grid');
        // Swiper only recognizes direct children that carry the slide class.
        // Galleries that don't hard-code it in the markup need it added here.
        Array.from(this.itemsWrapper.children).forEach((slide) => slide.classList.add('swiper-slide'));

        this.sliderOptions = {
          slidesPerView: mobileItems + peek,
          spaceBetween: columnGap.mobile,
          navigation: {
            nextEl: this.controlsRoot.querySelector('.swiper-button-next'),
            prevEl: this.controlsRoot.querySelector('.swiper-button-prev'),
          },
          threshold: 2,
          breakpoints: {
            768: {
              slidesPerView: tabletItems + peek,
              spaceBetween: columnGap.tablet,
            },
            1024: {
              slidesPerView: Math.min(items, 4) + peek,
              spaceBetween: columnGap.tabletLarge,
            },
            1280: {
              slidesPerView: items + peek,
              spaceBetween: columnGap.desktop,
            },
          },
        };

        this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions);
        this.sliderInstance.init();
      }

      disconnectedCallback() {
        if (typeof this.sliderInstance === 'object' && this.sliderInstance.slider) {
          this.sliderInstance.slider.destroy();
        }
      }
    }
  );
}
